import React from "react";
import { ReactComponent as GithubIcon } from "../../images/github-icon.svg";
import { ReactComponent as LinkedInIcon } from "../../images/linkedin-icon.svg";
import { ReactComponent as MailIcon } from "../../images/mail-icon.svg";
import UserData from "../../userdata.json";
function Footer() {
  const { intro, socials } = UserData || {};
  const { github, linkedin, mail } = socials || {};
  return (
    <div className="glassmorphic-2 bt flex justify-center mt4 ">
      <div className="flex w-80 mt4  justify-center items-center flex-row-l flex-column">
        <div className="f1-l f2 fw5 logo mr7-l">
          <b>{intro?.name || ""}</b>
        </div>
        <div className="mt2 mt0-l flex flex-column items-center items-baseline-l  justify-center">
          <div className="f4-l f5 flex flex-column items-baseline-l  items-center justify-center">
            <div>
              <img
                className="w1 h1"
                src="https://img.icons8.com/ios-filled/50/8a8a8a/marker.png"
                alt="marker"
              />
              <span className="ml2">India</span>
            </div>
            <div className="mt3 flex items-center">
              <MailIcon className="primary w1 h1 " />
              <span className="ml2">utkarshverma782@gmail.com</span>
            </div>
          </div>
          <div className="mt4 flex mb3">
            {mail ? (
              <a
                className="glassmorphic-2 ba pa3  br-100 svg-path-stroke-tertiary pointer mr3 "
                href={`mailto:${mail}`}
              >
                <MailIcon
                  // width={25}
                  // height={25}
                  className="primary w1 h1 svgstroke-transition"
                />
              </a>
            ) : null}
            {github ? (
              <a
                href={github}
                target="_blank"
                rel="noreferrer"
                className="ba glassmorphic-2 pa3  br-100 svg-path-fill-tertiary pointer mr3"
              >
                <GithubIcon
                  // width={25}
                  // height={25}
                  className="primary w1 h1  svgfill-transition"
                />
              </a>
            ) : null}
            {linkedin ? (
              <a
                href={linkedin}
                target="_blank"
                rel="noreferrer"
                className="ba glassmorphic-2 pa3  br-100 svg-path-fill-tertiary pointer "
              >
                <LinkedInIcon
                  // width={25}
                  // height={25}
                  className="primary w1 h1  svgfill-transition"
                />
              </a>
            ) : null}
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
}

export default Footer;
